<template>
    <Head title="Projects" />

    <BreezeAuthenticatedLayout>

      <main class="container">

        <div class="py-12">

          <div class="c-header">
            <a href="" onclick="javascript:history.back(); return false;" class="c-header__back">
              <img src="/images/icons/icon-chevron-left.svg" alt="back">
            </a>
            <h2 class="c-header--h2">カテゴリーを追加：{{ gym.title }}</h2>
          </div>

              <!-- This example requires Tailwind CSS v2.0+ -->
              <div class="flex flex-col">
 
                <div class="grid place-content-center mt-10">
                  <form @submit.prevent="storeProject" class="bg-white shadow-md m-2 p-2 rounded">
                    <div class="mt-24">
                      <label for="title" class="block text-sm font-medium text-gray-700"> カテゴリー </label>
                      <div class="mt-1">
                        <input type="text" id="name" name="name" v-model="form.name">
                      </div>
                    </div>

                    <div class="mt-24">
                      <label for="memo" class="block text-sm font-medium text-gray-700"> メモ </label>
                      <div class="mt-1">
                        <textarea v-model="form.memo" name="memo" placeholder="備考欄"></textarea>
                      </div>
                    </div>
                    <div class="mt-24">
                      <input type="hidden" name="gym_id" id="gym_id" v-model="form.gym_id">
                      <button type="submit" class="c-button">追加する</button>
                    </div>
                  </form>
                </div>

              </div>


            </div>

        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
  import { ref, watchEffect } from 'vue'
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Side
    },
    props: {
      gym: Object
    },
    setup(props) {
      const form = useForm({
        name: null,
        gym_id: props.gym.id,
        memo: null,
      });

      const grades = props.grades

      const startdate = ref(null)
      const enddate = ref(null)

      return {
        form
      }
    },
    methods: {
      storeProject() {
        this.form.post('/categories')
      }
    }
  }

</script>
